/**
 * Stripe Module
 *
 * Centralized exports for Stripe payment integration.
 */

// Provider
export { StripeProvider, useStripeContext, useIsMockStripe } from './StripeProvider';
export type { InitPaymentSheetParams, PaymentSheetResult } from './StripeProvider';

// Payment Service
export { paymentService, PaymentService } from './payment-service';
export type {
  CreateSubscriptionParams,
  CreateSubscriptionResult,
  UpdateSubscriptionParams,
  CancelSubscriptionParams,
  CustomerPortalResult,
} from './payment-service';

// Hook
export { useSubscription } from './useSubscription';
export type { UseSubscriptionReturn } from './useSubscription';

// Webhook Types
export type {
  WebhookEvent,
  WebhookEventType,
  StripeSubscription,
  StripeInvoice,
  StripeCheckoutSession,
  StripeCustomer,
  StripePaymentMethod,
} from './webhook-types';
export { createMockEvent, isSubscriptionEvent, isInvoiceEvent, isCheckoutEvent } from './webhook-types';

// Lifecycle Manager
export {
  subscriptionLifecycle,
  GRACE_PERIOD_DAYS,
  MAX_RETRY_ATTEMPTS,
} from './subscription-lifecycle';
export type { LifecycleEvent, LifecycleEventHandler } from './subscription-lifecycle';
